import { lazy } from 'react'
import { Route, Navigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { ProtectedRoute } from './ProtectedRoute'

const LoginPage = lazy(() =>
  import('@/pages/auth/LoginPage').then((m) => ({ default: m.LoginPage }))
)
const DashboardPage = lazy(() =>
  import('@/pages/DashboardPage').then((m) => ({ default: m.DashboardPage }))
)
const ProductsPage = lazy(() =>
  import('@/pages/products/ProductsPage').then((m) => ({
    default: m.ProductsPage,
  }))
)
const CategoriesPage = lazy(() =>
  import('@/pages/categories/CategoriesPage').then((m) => ({
    default: m.CategoriesPage,
  }))
)
const OrdersPage = lazy(() =>
  import('@/pages/orders/OrdersPage').then((m) => ({ default: m.OrdersPage }))
)
const OrderDetailPage = lazy(() =>
  import('@/pages/orders/OrderDetailPage').then((m) => ({
    default: m.OrderDetailPage,
  }))
)
const CustomersPage = lazy(() =>
  import('@/pages/customers/CustomersPage').then((m) => ({
    default: m.CustomersPage,
  }))
)
const BannersPage = lazy(() =>
  import('@/pages/banners/BannersPage').then((m) => ({ default: m.BannersPage }))
)
const CouponsPage = lazy(() =>
  import('@/pages/coupons/CouponsPage').then((m) => ({ default: m.CouponsPage }))
)
const InventoryPage = lazy(() =>
  import('@/pages/inventory/InventoryPage').then((m) => ({
    default: m.InventoryPage,
  }))
)
const RawMaterialsPage = lazy(() =>
  import('@/pages/raw-materials/RawMaterialsPage').then((m) => ({
    default: m.RawMaterialsPage,
  }))
)
const SettingsPage = lazy(() =>
  import('@/pages/settings/SettingsPage').then((m) => ({
    default: m.SettingsPage,
  }))
)
const TrafficAnalyticsPage = lazy(() =>
  import('@/pages/traffic/TrafficAnalyticsPage').then((m) => ({
    default: m.TrafficAnalyticsPage,
  }))
)
const ChangePasswordPage = lazy(() =>
  import('@/pages/auth/ChangePasswordPage').then((m) => ({
    default: m.ChangePasswordPage,
  }))
)
const ContactSubmissionsPage = lazy(() =>
  import('@/pages/contact/ContactSubmissionsPage').then((m) => ({
    default: m.ContactSubmissionsPage,
  }))
)
const ProductRequestsPage = lazy(() =>
  import('@/pages/product-requests/ProductRequestsPage').then((m) => ({
    default: m.ProductRequestsPage,
  }))
)
const BugReportsPage = lazy(() =>
  import('@/pages/bug-reports/BugReportsPage').then((m) => ({
    default: m.BugReportsPage,
  }))
)
const OrderReturnRequestsPage = lazy(() =>
  import('@/pages/order-returns/OrderReturnRequestsPage').then((m) => ({
    default: m.OrderReturnRequestsPage,
  }))
)
const ProductReviewsPage = lazy(() =>
  import('@/pages/product-reviews/ProductReviewsPage').then((m) => ({
    default: m.ProductReviewsPage,
  }))
)

export function AdminRoutes() {
  return (
    <>
      <Route path="/admin/login" element={<LoginPage />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="traffic" element={<TrafficAnalyticsPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="categories" element={<CategoriesPage />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="orders/:id" element={<OrderDetailPage />} />
        <Route path="customers" element={<CustomersPage />} />
        <Route path="banners" element={<BannersPage />} />
        <Route path="coupons" element={<CouponsPage />} />
        <Route path="inventory" element={<InventoryPage />} />
        <Route path="raw-materials" element={<RawMaterialsPage />} />
        <Route path="change-password" element={<ChangePasswordPage />} />
        <Route path="contact-messages" element={<ContactSubmissionsPage />} />
        <Route path="product-requests" element={<ProductRequestsPage />} />
        <Route path="bug-reports" element={<BugReportsPage />} />
        <Route path="order-returns" element={<OrderReturnRequestsPage />} />
        <Route path="product-reviews" element={<ProductReviewsPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="/login" element={<Navigate to="/admin/login" replace />} />
    </>
  )
}
